"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var moment = require("moment");
var core_1 = require("@athena-portal/core");
var LvFlowProgressBarWidget_1 = require("./progressBar/LvFlowProgressBarWidget");
var commonFunctions_1 = require("../commonFunctions");
var MaintenanceBannerWidget_1 = require("../widgets/banners/MaintenanceBannerWidget");
var AnnualMotorProgressBarSettings_1 = require("./progressBar/AnnualMotorProgressBarSettings");
var DriveAwayProgressBarSettings_1 = require("./progressBar/DriveAwayProgressBarSettings");
var portal_core_1 = require("@ferry/portal-core");
var LvFalconNavigator = /** @class */ (function (_super) {
    __extends(LvFalconNavigator, _super);
    function LvFalconNavigator(props) {
        var _a, _b;
        var _this = _super.call(this, props) || this;
        _this.skipDefault = function (event) {
            event.preventDefault();
        };
        _this.showProgressBar = true;
        _this.showLock = false;
        _this.showTitle = true;
        _this.showWordingBelowJourneyButtons = false;
        _this.isAnnualProduct = (0, commonFunctions_1.isAnnualProduct)((_a = _this.props.interaction) === null || _a === void 0 ? void 0 : _a.product);
        _this.isDriveAwayProduct = (0, commonFunctions_1.isDriveAwayProduct)((_b = _this.props.interaction) === null || _b === void 0 ? void 0 : _b.product);
        if (_this.isAnnualProduct) {
            _this.progressBarSettings = new AnnualMotorProgressBarSettings_1.AnnualMotorProgressBarSettings();
        }
        if (_this.isDriveAwayProduct) {
            _this.progressBarSettings = new DriveAwayProgressBarSettings_1.DriveAwayProgressBarSettings();
        }
        _this.state = {
            errorShown: false,
            backgroundStyle: { height: "0px", top: "0px" }
        };
        _this.clickPrev = _this.clickPrev.bind(_this);
        _this.preClickNext = _this.preClickNext.bind(_this);
        _this.clickNext = _this.clickNext.bind(_this);
        _this.clickLogo = _this.clickLogo.bind(_this);
        return _this;
    }
    LvFalconNavigator.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        var errorShown = false;
        for (var _i = 0, _a = Object.keys(this.props.validations); _i < _a.length; _i++) {
            var questionName = _a[_i];
            var validationResult = this.props.validations[questionName];
            if (validationResult.errors && validationResult.errors.length > 0) {
                errorShown = true;
            }
        }
        if (prevState.errorShown !== errorShown) {
            this.getJourneyBackground();
        }
    };
    LvFalconNavigator.prototype.componentDidMount = function () {
        var _this = this;
        setTimeout(function () {
            _this.getJourneyBackground();
        }, 500);
        window.addEventListener('resize', this.getJourneyBackground.bind(this));
    };
    LvFalconNavigator.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.getJourneyBackground);
    };
    LvFalconNavigator.prototype.componentDidCatch = function (error, errorInfo) {
        var _a, _b, _c;
        this.journeyRuntimeService.doBackendAction("log", this.props.interaction, {
            level: "ERROR",
            message: "JRE: exception: ".concat(error.message ? error.message : "", "\n    Interaction id: ").concat((_a = this.props.interaction._id) !== null && _a !== void 0 ? _a : "-", "\n    Product: ").concat(this.props.product || "-", "\n    Process: ").concat(this.props.process || "-", "\n    Page: ").concat((_b = this.props.page) === null || _b === void 0 ? void 0 : _b.pageId, "\n    ComponentStack: ").concat(errorInfo.componentStack || "-", "\n    Stack: ").concat((_c = error.stack) !== null && _c !== void 0 ? _c : "-")
        }, false).subscribe();
    };
    LvFalconNavigator.prototype.render = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        var isQuotePage = ((_a = this.props.page) === null || _a === void 0 ? void 0 : _a.pageId) === 'summary';
        var isDriveAwayProduct = this.props.interaction.product === 'DriveAwayInsurance';
        var brandName = String((_c = (_b = this.props.interaction) === null || _b === void 0 ? void 0 : _b.brandName) !== null && _c !== void 0 ? _c : '');
        var stickyPricePresent = (_e = (_d = this.props.page) === null || _d === void 0 ? void 0 : _d.questions) === null || _e === void 0 ? void 0 : _e.some(function (e) { return e.type === "stickyPrice"; });
        var stickyPricePadding = stickyPricePresent && this.showProgressBar ? " padding-top-80-not-important" : "";
        var title = isQuotePage && ((_f = this.props.page) === null || _f === void 0 ? void 0 : _f.title) ? "".concat((0, portal_core_1.getPrettifiedInteractionBrandName)(brandName), " annual car insurance") : (_g = this.props.page) === null || _g === void 0 ? void 0 : _g.title;
        var driveAwayTitle = isQuotePage && ((_h = this.props.page) === null || _h === void 0 ? void 0 : _h.title) && isDriveAwayProduct ? "".concat((0, portal_core_1.getPrettifiedInteractionBrandName)(brandName), " Drive away car insurance") : (_j = this.props.page) === null || _j === void 0 ? void 0 : _j.title;
        this.mapInteractionToDataLayer();
        return ((0, jsx_runtime_1.jsxs)(React.Fragment, { children: [this.renderHeader(), this.renderProgressBar(), (0, jsx_runtime_1.jsxs)("div", { className: "journey-content".concat(stickyPricePadding), children: [(0, jsx_runtime_1.jsxs)("div", { className: "journey-questions", children: [(((_k = this.props.page) === null || _k === void 0 ? void 0 : _k.pageId) === 'numberPlateScan' || ((_l = this.props.page) === null || _l === void 0 ? void 0 : _l.pageId) === "carDetails") &&
                                    (0, jsx_runtime_1.jsx)("div", { className: "logoBanner", children: (0, jsx_runtime_1.jsx)("img", { src: "/".concat(portal_core_1.resourcesHelper.THEME_PATH, "/img/details_logo.png"), alt: "".concat(portal_core_1.resourcesHelper.THEME, " details logo") }) }), this.showTitle && ((0, jsx_runtime_1.jsxs)("div", { className: "journey-questions-title", children: [(((_m = this.props.page) === null || _m === void 0 ? void 0 : _m.pageId) !== "decline") && (this.props.process === 'nb' || this.props.process.startsWith("mta")) && !isDriveAwayProduct &&
                                            (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [this.showLock ? (0, jsx_runtime_1.jsx)("h1", { children: (0, jsx_runtime_1.jsx)("span", { children: title }) }) :
                                                        (0, jsx_runtime_1.jsx)("h1", { children: title }), (0, jsx_runtime_1.jsx)(MaintenanceBannerWidget_1.MaintenanceBannerWidget, { product: this.props.product })] }), (((_o = this.props.page) === null || _o === void 0 ? void 0 : _o.pageId) !== "decline") && (this.props.process === 'nb' || this.props.process.startsWith("mta")) && isDriveAwayProduct &&
                                            (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [this.showLock ? (0, jsx_runtime_1.jsx)("h1", { children: (0, jsx_runtime_1.jsx)("span", { children: driveAwayTitle }) }) :
                                                        (0, jsx_runtime_1.jsx)("h1", { children: driveAwayTitle }), (0, jsx_runtime_1.jsx)(MaintenanceBannerWidget_1.MaintenanceBannerWidget, { product: this.props.product })] })] })), (0, jsx_runtime_1.jsx)("div", { className: "journey-questions-body", children: (0, jsx_runtime_1.jsx)("div", { className: "journey-questions-body-content", children: this.props.children }) })] }), (this.props.page && (this.props.page.nextPage || this.props.page.prevPage)) &&
                            (0, jsx_runtime_1.jsx)("div", { className: "journey-buttons", children: (0, jsx_runtime_1.jsxs)("div", { className: "journey-buttons-content", children: [this.renderNextButton(), this.renderBackButton(), (this.showWordingBelowJourneyButtons) &&
                                            this.renderWordingBelowJourneyButtons()] }) })] }), this.renderFooter()] }));
    };
    LvFalconNavigator.prototype.clickPrev = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, _super.prototype.clickPrev.call(this)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.props.engine.validate()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, Promise.resolve()];
                }
            });
        });
    };
    LvFalconNavigator.prototype.preClickNext = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        event.target.focus();
                        return [4 /*yield*/, this.clickNext()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    LvFalconNavigator.prototype.clickNext = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, _super.prototype.clickNext.call(this)];
                    case 1:
                        _c.sent();
                        if ((0, commonFunctions_1.isPageValid)(this.props.pageValidations, this.props.validations)) {
                            this.props.engine.setJourneyState((_a = {},
                                _a["hidePageValidationErrorMessage"] = true,
                                _a["hideUnansweredWarning"] = true,
                                _a));
                        }
                        else {
                            this.props.engine.setJourneyState((_b = {},
                                _b["hidePageValidationErrorMessage"] = false,
                                _b["hideUnansweredWarning"] = false,
                                _b));
                        }
                        return [2 /*return*/, Promise.resolve()];
                }
            });
        });
    };
    LvFalconNavigator.prototype.clickLogo = function () {
        window.location.href = "/dashboard";
    };
    LvFalconNavigator.prototype.renderBackButton = function () {
        var _a, _b;
        if (!this.props.page) {
            return null;
        }
        if (this.props.page.prevPage) {
            return ((0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn btn-back", onMouseDown: this.skipDefault, onTouchStart: this.skipDefault, onClick: this.clickPrev, id: "navigatorBack", children: (_b = (_a = this.props.page) === null || _a === void 0 ? void 0 : _a.prevPageLabel) !== null && _b !== void 0 ? _b : "Back" }));
        }
        return null;
    };
    LvFalconNavigator.prototype.renderNextButton = function () {
        var _a, _b;
        if (!this.props.page) {
            return null;
        }
        if (this.props.page.nextPage) {
            var withoutBackButtonCssClass = this.isBackButtonExists() ? "" : " btn-next-without-back-button";
            var cssClasses = "btn btn-primary" + " btn-next-arrow-separate btn-next-mobile-margin" + withoutBackButtonCssClass;
            return ((0, jsx_runtime_1.jsxs)("button", { type: "button", className: cssClasses, onMouseDown: this.skipDefault, onTouchStart: this.skipDefault, onClick: this.preClickNext, id: "navigatorNext", children: [(_b = (_a = this.props.page) === null || _a === void 0 ? void 0 : _a.nextPageLabel) !== null && _b !== void 0 ? _b : "Next", (0, jsx_runtime_1.jsx)("img", { className: "arrow-next", alt: "Arrow icon", src: "/img/arrow-next.png" })] }));
        }
        return null;
    };
    LvFalconNavigator.prototype.renderProgressBar = function () {
        if (!this.showProgressBar) {
            return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
        }
        var percentageByPageId = this.progressBarSettings ? this.progressBarSettings.getPercentageByPageId(this.props.page.pageId) : null;
        if (percentageByPageId === null) {
            return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
        }
        return (0, jsx_runtime_1.jsx)(LvFlowProgressBarWidget_1.default, { percentage: percentageByPageId });
    };
    LvFalconNavigator.prototype.renderHeader = function () {
        return ((0, jsx_runtime_1.jsx)("div", { className: "journey-header", children: (0, jsx_runtime_1.jsx)("div", { className: "journey-header-background", children: (0, jsx_runtime_1.jsx)("a", { className: "header-logo-link", id: "goToHelloPage", href: "/", target: "_blank", "aria-label": "Link to hello page", children: (0, jsx_runtime_1.jsx)("img", { className: "logo", src: "/".concat(portal_core_1.resourcesHelper.THEME_PATH, "/img/brand-logo.svg"), alt: "".concat(portal_core_1.resourcesHelper.THEME, " logo icon") }) }) }) }));
    };
    LvFalconNavigator.prototype.renderFooter = function () {
        return (0, jsx_runtime_1.jsx)(portal_core_1.Footer, {});
    };
    LvFalconNavigator.prototype.renderWordingBelowJourneyButtons = function () {
        var brandName = (0, portal_core_1.getPrettifiedInteractionBrandName)(this.props.interaction.brandName);
        return ((0, jsx_runtime_1.jsxs)("p", { className: "mb-4", children: ["Volkswagen Financial Services (UK) Ltd is an introducer to ", brandName, " Car Insurance, underwritten by Liverpool Victoria Insurance Company Limited, and gets paid a commission for this. ", (0, jsx_runtime_1.jsx)("br", {}), "Please contact us for further details of this commission arrangement."] }));
    };
    LvFalconNavigator.prototype.mapInteractionToDataLayer = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
        if (this.props.interaction) {
            var policyHolder = (_a = this.props.interaction.policyHolder) !== null && _a !== void 0 ? _a : null;
            var address = (_b = policyHolder === null || policyHolder === void 0 ? void 0 : policyHolder.address) !== null && _b !== void 0 ? _b : null;
            var factors = (_c = this.props.interaction.factors) !== null && _c !== void 0 ? _c : null;
            var underwritingResult = this.props.interaction.underwritingResult && this.props.interaction.underwritingResult.length > 0 ? this.props.interaction.underwritingResult[0] : null;
            var vehicleCount = this.props.interaction.vehicles ? this.props.interaction.vehicles.length : 0;
            var startDate = this.props.interaction.headerInfo ? moment(this.props.interaction.headerInfo.startDate).format("DD/MM/YYYY") : null;
            var realEstate = (_e = (_d = this.props.interaction.realEstate) === null || _d === void 0 ? void 0 : _d[0]) !== null && _e !== void 0 ? _e : null;
            var paymentDay = (_f = this.props.interaction.paymentDay) !== null && _f !== void 0 ? _f : null;
            var additionalDrivers = this.props.interaction.additionalDrivers && this.props.interaction.additionalDrivers.length > 0 ? this.props.interaction.additionalDrivers : null;
            var ownsHome = (policyHolder === null || policyHolder === void 0 ? void 0 : policyHolder.ownsHome) ? "Yes" : "No";
            var hasClaims = (policyHolder === null || policyHolder === void 0 ? void 0 : policyHolder.hasClaims) ? "Y" : "N";
            var hasConvictions = (policyHolder === null || policyHolder === void 0 ? void 0 : policyHolder.hasConvictions) ? "Yes" : "No";
            var marketingPreferenceEmail = (policyHolder === null || policyHolder === void 0 ? void 0 : policyHolder.marketingPreferencesEmail) ? "Y" : "N";
            var marketingPreferencePhone = (policyHolder === null || policyHolder === void 0 ? void 0 : policyHolder.marketingPreferencesPhone) ? "Y" : "N";
            var marketingPreferencePost = (policyHolder === null || policyHolder === void 0 ? void 0 : policyHolder.marketingPreferencesPost) ? "Y" : "N";
            var marketingPreferenceSms = (policyHolder === null || policyHolder === void 0 ? void 0 : policyHolder.marketingPreferencesSMS) ? "Y" : "N";
            var liveAlone = (realEstate === null || realEstate === void 0 ? void 0 : realEstate.hasNoOtherResidents) ? "Y" : "N";
            var gotKids = (realEstate === null || realEstate === void 0 ? void 0 : realEstate.childrenAtProperty) ? "Y" : "N";
            var hasSecondaryOccupation = (policyHolder === null || policyHolder === void 0 ? void 0 : policyHolder.hasSecondaryOccupation) ? "Y" : "N";
            var nonMotoringConvictions = (policyHolder === null || policyHolder === void 0 ? void 0 : policyHolder.hasUnspentCriminalConvictions) ? "Y" : "N";
            var protectedNcd = ((_g = policyHolder === null || policyHolder === void 0 ? void 0 : policyHolder.ncd) === null || _g === void 0 ? void 0 : _g.doNotDisclose) ? "Y" : "N";
            var ukResidentOver3Years = (policyHolder === null || policyHolder === void 0 ? void 0 : policyHolder.residentOfUKMoreThanThreeYears) ? "Y" : "N";
            var isMainHome = (realEstate === null || realEstate === void 0 ? void 0 : realEstate.isMainHome) ? "Y" : "N";
            var hasJointPolicyHolder = (policyHolder === null || policyHolder === void 0 ? void 0 : policyHolder.hasJointPolicyHolder) ? "Y" : "N";
            var monthlyPaymentAvailable = ((_j = (_h = this.props.interaction.paymentDetails) === null || _h === void 0 ? void 0 : _h.instalmentPlan) === null || _j === void 0 ? void 0 : _j.instalmentPlanParameters) ? "Y" : "N";
            var isLeftEmpty = (realEstate === null || realEstate === void 0 ? void 0 : realEstate.isLeftEmpty) ? "Y" : "N";
            window.LvDataLayer = {
                screenResolution: window.innerWidth + "x" + window.innerHeight,
                pageTitle: this.props.page.title,
                previousPageTitle: this.props.page.prevPage,
                partner: "lv",
                // EmploymentStatus = 0 is possible for migrated interactions, but there is no such value in lookup
                employmentStatus: (policyHolder === null || policyHolder === void 0 ? void 0 : policyHolder.employmentStatus) && policyHolder.employmentStatus !== "0" ? this.fetchLookupValue("employmentStatus", policyHolder.employmentStatus) : null,
                maritalStatus: (policyHolder === null || policyHolder === void 0 ? void 0 : policyHolder.maritalStatus) ? this.fetchLookupValue("maritalStatus", policyHolder.maritalStatus) : null,
                ukResidency: (_k = policyHolder === null || policyHolder === void 0 ? void 0 : policyHolder.residencyLength) !== null && _k !== void 0 ? _k : null,
                ownsHome: (policyHolder === null || policyHolder === void 0 ? void 0 : policyHolder.ownsHome) != null ? ownsHome : null,
                claimsIndicated: (policyHolder === null || policyHolder === void 0 ? void 0 : policyHolder.hasClaims) != null ? hasClaims : null,
                convictionsIndicated: (policyHolder === null || policyHolder === void 0 ? void 0 : policyHolder.hasConvictions) !== null ? hasConvictions : null,
                yearOfBirth: (policyHolder === null || policyHolder === void 0 ? void 0 : policyHolder.dateOfBirth) ? this.extractYearFromDate(policyHolder.dateOfBirth) : null,
                emailAddress: policyHolder ? policyHolder.email : null,
                postCode: address ? address.outwardPostcode : null,
                numberOfDrivers: null,
                totalPricePerMonth: factors ? factors.premium : null,
                priceRange: !this.isAnnualProduct ? this.getPriceRange(factors) : null,
                quoteReference: this.props.interaction._id,
                marketingPreferenceEmail: policyHolder ? marketingPreferenceEmail : null,
                marketingPreferencePhone: policyHolder ? marketingPreferencePhone : null,
                marketingPreferencePost: policyHolder ? marketingPreferencePost : null,
                marketingPreferenceSms: policyHolder ? marketingPreferenceSms : null,
                policyReference: this.props.interaction.agreementNumber,
                failedUwRule: underwritingResult ? underwritingResult.objectName : null,
                vehicles: this.getVehicleData(),
                numberOfCars: vehicleCount,
                multipleCars: null,
                documentMethod: (policyHolder === null || policyHolder === void 0 ? void 0 : policyHolder.sendDocumentsByPost) ? "Post" : "Email",
                startingProduct: this.getDataLayerProduct(),
                coverStartDate: startDate,
                liveAlone: realEstate ? liveAlone : null,
                homeClaimsIndicated: null,
                propertyType: realEstate && this.getTypeOrKindOfProperty(realEstate, true),
                kindOfProperty: realEstate && this.getTypeOrKindOfProperty(realEstate, false),
                numberOfFamilyMembers: realEstate === null || realEstate === void 0 ? void 0 : realEstate.adultFamilyMemberCount,
                numberOfHousemates: realEstate === null || realEstate === void 0 ? void 0 : realEstate.housemateCount,
                gotKids: realEstate ? gotKids : null,
                typeOfTenancy: (realEstate === null || realEstate === void 0 ? void 0 : realEstate.furnishingType) && this.fetchLookupValue("furnishingType", realEstate.furnishingType),
                numberOfBedrooms: (_l = realEstate === null || realEstate === void 0 ? void 0 : realEstate.bedroomCount) !== null && _l !== void 0 ? _l : null,
                numberOfBathrooms: (_m = realEstate === null || realEstate === void 0 ? void 0 : realEstate.bathroomCount) !== null && _m !== void 0 ? _m : null,
                includedItemsWorthMoreThan2K: null,
                wantCoverAwayFromHome: null,
                coverLimit: null,
                accidentalDamageToContents: null,
                homeExcess: null,
                homeStartDate: null,
                licenceHandy: this.isAnnualProduct && policyHolder ? policyHolder.drivingLicenceHandy : null,
                title: this.isAnnualProduct && policyHolder ? policyHolder.title : null,
                firstName: policyHolder ? policyHolder.firstName : null,
                lastName: policyHolder ? policyHolder.lastName : null,
                dln: (_p = (_o = policyHolder === null || policyHolder === void 0 ? void 0 : policyHolder.licence) === null || _o === void 0 ? void 0 : _o.number) !== null && _p !== void 0 ? _p : null,
                licenceType: ((_q = policyHolder === null || policyHolder === void 0 ? void 0 : policyHolder.licence) === null || _q === void 0 ? void 0 : _q.type) ? this.fetchLookupValue("licenceType", policyHolder.licence.type.toString()) : null,
                licenceHeldYears: this.isAnnualProduct && (policyHolder === null || policyHolder === void 0 ? void 0 : policyHolder.drivingExperience) ? this.fetchLookupValue("drivingExperienceOpts", policyHolder.drivingExperience.toString()) : null,
                occupation: this.isAnnualProduct && (policyHolder === null || policyHolder === void 0 ? void 0 : policyHolder.occupation) ? this.fetchLookupValue("wolfOccupation", policyHolder.occupation) : null,
                occupationIndustry: this.isAnnualProduct && (policyHolder === null || policyHolder === void 0 ? void 0 : policyHolder.occupationIndustry) ? this.fetchLookupValue("wolfOccupationIndustry", policyHolder.occupationIndustry) : null,
                hasSecondaryOccupation: this.isAnnualProduct && policyHolder ? hasSecondaryOccupation : null,
                secondaryOccupation: this.isAnnualProduct && (policyHolder === null || policyHolder === void 0 ? void 0 : policyHolder.secondaryOccupation) ? this.fetchLookupValue("wolfOccupation", policyHolder.secondaryOccupation) : null,
                numberOfClaims: policyHolder ? policyHolder.numberOfClaims : null,
                ukResidentOver3Years: this.isAnnualProduct && policyHolder ? ukResidentOver3Years : null,
                residencyTerm: this.isAnnualProduct && (policyHolder === null || policyHolder === void 0 ? void 0 : policyHolder.residencyTerm) ? this.fetchLookupValue("residencyTerms", policyHolder.residencyTerm.toString()) : null,
                nonMotoringConvictions: (policyHolder === null || policyHolder === void 0 ? void 0 : policyHolder.hasUnspentCriminalConvictions) != null ? nonMotoringConvictions : null,
                ncdYears: this.isAnnualProduct && (policyHolder === null || policyHolder === void 0 ? void 0 : policyHolder.ncd) ? policyHolder.ncd.yearCount : null,
                ncdEarningType: (this.isAnnualProduct && ((_r = policyHolder === null || policyHolder === void 0 ? void 0 : policyHolder.ncd) === null || _r === void 0 ? void 0 : _r.earningType)) ? this.fetchLookupValue("ncdEarnType", policyHolder.ncd.earningType.toString()) : null,
                protectedNcd: this.isAnnualProduct && (policyHolder === null || policyHolder === void 0 ? void 0 : policyHolder.ncd) ? protectedNcd : null,
                carsInHousehold: policyHolder ? policyHolder.carsInHousehold : null,
                paymentOption: this.isAnnualProduct && factors ? factors.premiumType : null,
                coverType: this.isAnnualProduct ? "COMPREHENSIVE" : null,
                automaticRenewal: this.isAnnualProduct && policyHolder ? policyHolder.automaticRenewal : null,
                paymentDay: paymentDay ? paymentDay.day : null,
                addDriver: (additionalDrivers ? "Y" : "N"),
                annualPremium: this.isAnnualProduct && factors ? factors.annualPremium : null,
                externalWallMaterial: (realEstate === null || realEstate === void 0 ? void 0 : realEstate.externalWallMaterial) ? this.fetchLookupValue("wallMaterial", realEstate.externalWallMaterial) : null,
                roofMaterial: (realEstate === null || realEstate === void 0 ? void 0 : realEstate.roofMaterial) ? this.fetchLookupValue("roofMaterial", realEstate.roofMaterial.toString()) : null,
                yearBuilt: (_s = realEstate === null || realEstate === void 0 ? void 0 : realEstate.yearBuilt) !== null && _s !== void 0 ? _s : null,
                propertyListing: (realEstate === null || realEstate === void 0 ? void 0 : realEstate.propertyListing) ? this.fetchLookupValue("propertyListing", realEstate.propertyListing) : null,
                isMainHome: (realEstate === null || realEstate === void 0 ? void 0 : realEstate.isMainHome) != null ? isMainHome : null,
                residentsType: (realEstate === null || realEstate === void 0 ? void 0 : realEstate.residentsType) ? this.fetchLookupValue("residencyUsage", realEstate.residentsType) : null,
                numberOfChildren: (_t = realEstate === null || realEstate === void 0 ? void 0 : realEstate.numberOfChildren) !== null && _t !== void 0 ? _t : null,
                isLeftEmpty: (realEstate === null || realEstate === void 0 ? void 0 : realEstate.isLeftEmpty) != null ? isLeftEmpty : null,
                ownershipType: (realEstate === null || realEstate === void 0 ? void 0 : realEstate.ownershipType) ? this.fetchLookupValue("propertyOwnershipType", realEstate.ownershipType) : null,
                yearsAtProperty: policyHolder ? policyHolder.yearsAtProperty : null,
                homePolicyHolderTitle: (policyHolder === null || policyHolder === void 0 ? void 0 : policyHolder.title) ? this.fetchLookupValue("homePolicyHolderTitle", policyHolder.title) : null,
                hasJointPolicyHolder: (policyHolder === null || policyHolder === void 0 ? void 0 : policyHolder.hasJointPolicyHolder) != null ? hasJointPolicyHolder : null,
                monthlyPaymentAvailable: this.props.interaction.paymentDetails ? monthlyPaymentAvailable : null,
                documentsByEmail: (policyHolder === null || policyHolder === void 0 ? void 0 : policyHolder.sendDocumentsByPost) ? "N" : "Y",
                coverTier: this.props.interaction.coverTier,
                contractType: (0, commonFunctions_1.getDataLayerContractType)(this.props.interaction),
                brand: (_u = this.props.interaction.brandName) !== null && _u !== void 0 ? _u : null,
                paymentType: (_w = (_v = this.props.interaction.paymentDetails) === null || _v === void 0 ? void 0 : _v.paymentType) !== null && _w !== void 0 ? _w : null,
                selectedProduct: (0, commonFunctions_1.getDataLayerSelectedProduct)(this.props.interaction),
                financialServicesCustomer: (policyHolder === null || policyHolder === void 0 ? void 0 : policyHolder.isFinancialServicesCustomer) ? "Yes" : "No",
                retailer: (_x = this.props.interaction.retailerNumber) !== null && _x !== void 0 ? _x : null
            };
        }
    };
    LvFalconNavigator.prototype.isBackButtonExists = function () {
        if (!this.props.page) {
            return false;
        }
        return this.props.page.prevPage != null;
    };
    LvFalconNavigator.prototype.extractYearFromDate = function (date) {
        return moment(date, moment.ISO_8601).year();
    };
    LvFalconNavigator.prototype.getPriceRange = function (factors) {
        if (factors) {
            return factors.neverLower + "-" + factors.neverHigher;
        }
        return null;
    };
    LvFalconNavigator.prototype.fetchLookupValue = function (fieldId, id) {
        var value = "";
        // use find instead of filter to avoid undefined value in case of no match
        this.lookupService.fetchLookupValues(fieldId, "en-UK").subscribe(function (lookupValues) {
            var _a;
            var found = Object.values(lookupValues).find(function (entry) { return entry.id === id; });
            value = (_a = found === null || found === void 0 ? void 0 : found.value) !== null && _a !== void 0 ? _a : "";
        });
        return value;
    };
    LvFalconNavigator.prototype.getVehicleData = function () {
        var _this = this;
        var vehicleInfo = [];
        if (this.props.interaction.vehicles) {
            var optionalExtras_1 = this.props.interaction.optionalExtras;
            this.props.interaction.vehicles.forEach(function (vehicle) {
                var _a, _b;
                var _c = _this.extractDisplayValues(optionalExtras_1, vehicle), legalProtection = _c.legalProtection, courtesyCar = _c.courtesyCar, manuallyChosen = _c.manuallyChosen, hasModifications = _c.hasModifications, trackerInstalled = _c.trackerInstalled, familyPackage = _c.familyPackage;
                var car = {
                    yearOfManufacture: vehicle.year,
                    fuelType: vehicle.fuelType ? _this.fetchLookupValue("vehicleFuelType", (0, commonFunctions_1.getInteractionVehicleFuelType)(vehicle.fuelType, vehicle.fuelTypeFull)) : null,
                    fuelTypeFull: (_b = (_a = vehicle.fuelTypeFull) === null || _a === void 0 ? void 0 : _a.fuelTypeFull) !== null && _b !== void 0 ? _b : null,
                    make: vehicle.make,
                    model: vehicle.model,
                    voluntaryExcess: _this.getVoluntaryExcess(vehicle),
                    courtesyCar: courtesyCar,
                    motorLegalExpensesCost: legalProtection ? optionalExtras_1 === null || optionalExtras_1 === void 0 ? void 0 : optionalExtras_1.motorLegalExpensesCost : null,
                    motorLegalExpenses: legalProtection,
                    courtesyCarCost: courtesyCar ? optionalExtras_1 === null || optionalExtras_1 === void 0 ? void 0 : optionalExtras_1.courtesyCarCost : null,
                    totalPricePerMonth: vehicle.ratingOutput ? vehicle.ratingOutput.grossPremium : null,
                    pricePerMonth: vehicle.ratingOutput ? vehicle.ratingOutput.roundedPremium : null,
                    regNumberProvided: vehicle.manuallyChosen != null ? manuallyChosen : null,
                    vrn: vehicle.registrationNumber,
                    transmission: vehicle.transmission ? _this.fetchLookupValue("vehicleTransmission", vehicle.transmission) : null,
                    modifications: vehicle.hasModifications != null ? hasModifications : null,
                    trackerInstalled: _this.isAnnualProduct && vehicle.trackerQuestionRequired ? trackerInstalled : null,
                    mileage: vehicle.mileage ? _this.fetchLookupValue("mileage", vehicle.mileage.toString()) : null,
                    carUsage: _this.isAnnualProduct && vehicle.classOfUse ? _this.fetchLookupValue("carUsage", vehicle.classOfUse) : null,
                    familyPackage: optionalExtras_1 ? familyPackage : null
                };
                vehicleInfo.push(car);
            });
        }
        return vehicleInfo;
    };
    LvFalconNavigator.prototype.extractDisplayValues = function (optionalExtras, vehicle) {
        var motorLegalExpenses = (optionalExtras === null || optionalExtras === void 0 ? void 0 : optionalExtras.motorLegalExpenses) ? "Y" : "N";
        var legalProtection = optionalExtras ? motorLegalExpenses : null;
        var courtesyCarString = (optionalExtras === null || optionalExtras === void 0 ? void 0 : optionalExtras.courtesyCar) ? "Y" : "N";
        var courtesyCar = optionalExtras ? courtesyCarString : null;
        var manuallyChosen = (vehicle === null || vehicle === void 0 ? void 0 : vehicle.manuallyChosen) ? "N" : "Y";
        var hasModifications = (vehicle === null || vehicle === void 0 ? void 0 : vehicle.hasModifications) ? "Y" : "N";
        var trackerInstalled = (vehicle === null || vehicle === void 0 ? void 0 : vehicle.trackerInstalled) ? "Y" : "N";
        var familyPackage = (optionalExtras === null || optionalExtras === void 0 ? void 0 : optionalExtras.familyPackage) ? "Y" : "N";
        return {
            legalProtection: legalProtection,
            courtesyCar: courtesyCar,
            manuallyChosen: manuallyChosen,
            hasModifications: hasModifications,
            trackerInstalled: trackerInstalled,
            familyPackage: familyPackage
        };
    };
    LvFalconNavigator.prototype.getTypeOrKindOfProperty = function (realEstate, type) {
        var estateTypeSubType = realEstate.realEstateTypeSubType ? this.fetchLookupValue("realEstateTypeSubType", realEstate.realEstateTypeSubType) : null;
        if (estateTypeSubType) {
            var lastWord = estateTypeSubType.split(" ").pop();
            return lastWord
                ? (type ? lastWord.charAt(0).toUpperCase() + lastWord.substring(1, lastWord.length) //nosonar
                    : estateTypeSubType.replace(lastWord, "").trim()) : null;
        }
        return null;
    };
    LvFalconNavigator.prototype.getVoluntaryExcess = function (vehicle) {
        if (this.isAnnualProduct && vehicle.annualVehicleExcess) {
            return vehicle.annualVehicleExcess.voluntaryExcess;
        }
        return null;
    };
    LvFalconNavigator.prototype.getDataLayerProduct = function () {
        if (this.isAnnualProduct) {
            return "Motor Annual";
        }
        return null;
    };
    LvFalconNavigator.prototype.getJourneyBackground = function () {
        var _this = this;
        setTimeout(function () {
            var backgroundCalcElements = document.querySelectorAll(".navigation-background-marker > *");
            var content = document.querySelector(".journey-questions");
            var validationError = document.querySelector(".validation-error-top");
            var elemHeight = 0;
            if (backgroundCalcElements !== null) {
                backgroundCalcElements.forEach(function (elem) {
                    elemHeight += _this.getElmHeight(elem);
                });
            }
            var errorShown = false;
            for (var _i = 0, _a = Object.keys(_this.props.validations); _i < _a.length; _i++) {
                var questionName = _a[_i];
                var validationResult = _this.props.validations[questionName];
                if (validationResult.errors && validationResult.errors.length > 0) {
                    errorShown = true;
                }
            }
            var validationElementHeight = 0;
            if (validationError !== null) {
                validationElementHeight = _this.getElmHeight(validationError) - 64;
            }
            if (content instanceof HTMLElement && elemHeight > 0) {
                var totalHeight = elemHeight + validationElementHeight;
                _this.setState({
                    errorShown: errorShown,
                    backgroundStyle: { height: totalHeight + "px", top: (content.offsetTop + 3) + "px" }
                });
            }
        }, 200);
    };
    LvFalconNavigator.prototype.getElmHeight = function (node) {
        var list = [
            'margin-top',
            'margin-bottom',
            'border-top',
            'border-bottom',
            'padding-top',
            'padding-bottom',
            'height'
        ];
        var style = window.getComputedStyle(node);
        return list
            .map(function (k) { return parseInt(style.getPropertyValue(k), 10); })
            .reduce(function (prev, cur) { return prev + cur; }, 0);
    };
    __decorate([
        (0, core_1.lazyInject)(plugin_journey_1.Types.LookupService),
        __metadata("design:type", Object)
    ], LvFalconNavigator.prototype, "lookupService", void 0);
    __decorate([
        (0, core_1.lazyInject)(plugin_journey_1.Types.JourneyRuntimeService),
        __metadata("design:type", Object)
    ], LvFalconNavigator.prototype, "journeyRuntimeService", void 0);
    return LvFalconNavigator;
}(plugin_journey_1.NavigatorWidgetBase));
exports.default = LvFalconNavigator;
//# sourceMappingURL=LvFalconNavigator.js.map